import React from 'react';
import { styled } from "../../../stitches.config";
import { bodyLarge } from "../../../redesign/commonStyles/Fonts";

const CtaSupportButton = () => {

    return (
        <CtaButton className={bodyLarge()}>
            <a data-analytics-name="article-cta-account-btn" href="tel:+48799394006">
                POTRZEBUJESZ WSPARCIA PSYCHOLOGICZNEGO?
                <br />
                ZADZWOŃ: 799 394 006
            </a>
        </CtaButton>
    )
};

const CtaButton = styled('div', {
    "a": {
        width: "100%",
        margin: "0 auto 18px auto",
        color: "#2689fc",
        backgroundColor: "#efefef",
        cursor: "pointer",
        padding: "16px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        fontWeight: 700,
        "&:hover": {
            backgroundColor: "#efefef",
        },
    }
})

export default CtaSupportButton